import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@shared-services/auth.service'

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService)
  const router = inject(Router)

  return auth.hasRole('SUPER_ADMIN')
    ? true
    : router.createUrlTree(['/'])
}
